import QuizPageContainer from './QuizPageContainer';

/*
* 문제 화면
*/
export default QuizPageContainer;